<template>

  	<v-row>
		<!-- FACTURA -->
		<div id="bill" style="display: none;">
			
			<div style="margin: 0 auto; text-align: center;">
			<br>
			<label style="font-size: medium; font-weight: bold;">Movimiento Inventario</label>
			<br>
			<label style="font-size: medium;">{{localidad}}</label>
			<br>
			<label style="font-size: medium;">Tipo Movimiento {{DatoMovimiento}}</label>
			<br>
			<label style="font-size: medium;">Usuario: {{$store.state.usuario.nombre}}</label>
			<br><br>
			<v-divider color="black"></v-divider>
			<br>
			</div>
			<div style="margin: 0 auto;">
			<label style="font-size: medium;">Fecha: {{Fecha}}</label> <br>
			<label style="font-size: medium;">Id Movimiento: {{idMovimiento}}</label>
			<br><br>
			<v-divider color="black"></v-divider>
			<br>
			<div style="display: grid; grid-template-columns: auto auto auto;">
				<table>
					<tr>
						<th>Descripcion</th>
						<th>Precio</th>
						<th>Cant</th>
					</tr>
					<tr v-for="item in detalles"
						:key="item">
						<td>{{item.descripcion}}</td>
						<td>{{item.precio}}</td>
						<td>{{item.cantidadIngreso}}</td>
					</tr>
					</table>
			</div>
			<br><br>
			<v-divider color="black"></v-divider>
			<br>
			</div>
		</div>
		<!-- FACTURA -->
        <v-card>
          <v-container fluid>
            <v-col cols="12" sm="12">
            <v-form ref="form" v-model="validFactura"  @submit.prevent="facturar">
            <v-row>
				
				<v-col cols="12" sm="4">
					<v-select filled v-model="localidad" label="Localidad" :items="Localidades"> </v-select>
              	</v-col>
				<v-col cols="12" sm="4">
					<v-text-field filled v-model="codigo" @keyup.enter="buscarCodigoBarras()"  label="Escanear Código"></v-text-field>
				</v-col>
              	<v-col cols="12" sm="4">
                 <v-select filled v-model="DatoMovimiento" :rules="[v => !!v || 'El tipo de movimiento es requerido']" :items="TipoMovimiento" label="Tipo de Movimiento"></v-select>
				</v-col>
                <v-col cols="12" sm="12">
                  <v-combobox filled clearable @change="buscarProducto()" @keyup.enter="buscarProducto()" :items="productos" v-model="codigo" label="Busqueda de producto por nombre"></v-combobox>
                </v-col>
                <v-col cols="12" sm="12">
                      <v-flex xs12 sm12 md12 lg12 xl12>
                        
                          <v-data-table
                              :headers="cabeceraDetalles"
                              single-select
                              :items="detalles"
                              class="elevation-1"
							  sort-desc=""
							  dense
							  sort-by="id"
                              v-model="selected"
                              @click:row="rowClick">
                              <template slot="no-data">
                                  <h3>No hay artículos agregados al detalle.</h3>
                              </template> 
                              <template v-slot:item.actionmovimiento="{ item }">
                                <v-icon
                                  large
                                  color="error"
                                  @click="eliminarProducto(item.id)"
                                >
                                  mdi-delete
                                </v-icon>
								</template>
                              	<template v-slot:item.actioncantidad="{ item }">
									<v-text-field
										onfocus="this.select();"
										autofocus
										v-model="item.cantidadIngreso"
										@keydown="preventNonNumericInput"
									></v-text-field>
								</template>

                          </v-data-table>
                      </v-flex>
				</v-col>
				<v-col class="mt-2" cols="12" sm="12">
                 <v-text-field v-model="detalle"  label="Detalle, comentario o justificación"></v-text-field>
              	</v-col>
                <v-btn :loading="loading" color="primary" @click="generarInventario()">
                Generar Proceso
                </v-btn>
              </v-row>
              </v-form>
              </v-col>
          </v-container>
        </v-card>
	</v-row>
  
</template>

<script>
import axios from 'axios'
import firebase from "firebase";
  export default {
    data: () => ({
		dialog: false,
		search: '',
		modelSeriales: false,
		MaxFactura:0,
		seriales: [],
	  	idMovimiento: 0,
		NombreVariacion:"",
		e1: 1,
		Selecciones:"",
		SeleccionesOpciones : [1,2,3,4,5,6,7,8,9,10],
		vencimiento: "",
		serial : "",
		sku:"",
		modeltrazlado:false,
		Talla:"",
		Color:"",
		CategoriaVariacion: "",
		dialogCompuesto:false,
		cat1: "",
		headers: [
			{ text: 'Opciones', value: 'action', sortable: false },
			{ text: 'Código', value: 'codigoProducto' },
			{ text: 'Nombre', value: 'descripcion' },
			{ text: 'Cat1', value: 'innerPack' },
			{ text: 'Cat2', value: 'tipoProducto',  },
			{ text: 'cat3', value: 'proveedor',  },
			{ text: 'Cod Barrs', value: 'barcode',  },
			{ text: 'Talla', value: 'medidas',  },
			{ text: 'SKU', value: 'codigoCaja',  },
			{ text: 'Descripcion', value: 'subFamilia', },
			{ text: 'Compuesto', value: 'compuesto', },
			{ text: 'Nic', value: 'pkg', },
			{ text: 'Ubicación', value: 'actividad', },
			{ text: 'Fecha', value: 'origen', },
			{ text: '% Puntos', value: 'comision', },
			{ text: 'Foto', value: 'actionImg', },
			{ text: 'Off-Online', value: 'sincServer1', },
		],
		Impuesto:[    
			{ text: '0% Excento', value: 0  },
			{ text: '1% Canasta Bàsica e Insumos', value: 1  }, 
			{ text: '2% Medicamentos, Primas, ect.' , value: 2  },
			{ text: '4% Boletos y Salud', value: 4  }, 
			{ text: '13% Tarifa General', value: 13  },                      
			],
			Compuestos:[    
				{ text: 'NO', value: false  },
				{ text: 'SI', value: true  },     
			],
			Proveedores:[    
				{ text: 'Mi Tienda', value: "Mi Tienda"  },              
			],
			Cocinas:[    
				{ text: 'NO', value: 0  },
				{ text: 'Cocina', value: 1  }, 
				{ text: 'Bar', value: 2  }, 
				{ text: 'Kiosko 1', value: 3  }, 
				{ text: 'Kiosko 2', value: 4  }, 
									
			],
		codigo: '',
		modelAprobaciones: false,
		tipoDocumentos: [
			'FISICA',
			'JURIDICA',
			'EXTRANJERO',
			],
		nombre: '',
		SubFamilia: '',
		stock: 0,
		modelproveedor: false,
		detalles:[],
		CompuestosItems:[],
		detalle: '',
		nicotina: 0,
		Localidades:[],
		modelAcabados: false,
		time:"",
		start: null,
		TipoCategoria: "",
		CategoriasTipo: ["Inventariado","Detalle"],
		chips: ['Azul', 'Verde'],
		OpcionesVariacion:[],
		ubicacion:'',
		menu21: null,
		Estados:["Suspendido","Disponible","Sin Stock"],
		Variaciones: [{Variacion:"Talla",Estado:true,Opciones:[
				{title: 'XS', Estado: "Suspendido"},
				{title: 'S', Estado: "Disponible"},
				{title: 'M',Estado: "Sin Stock"},
				{title: 'L',Estado: "Disponible"},
				{title: 'XL',Estado: "Suspendido"},
		]}, 
		{Variacion:"Color",Estado:true,Opciones:[
				{title: 'Negro', Estado: "Suspendido"},
				{title: 'Gris', Estado: "Disponible"},
				{title: 'Azul',Estado: "Sin Stock"},
				{title: 'Rosa',Estado: "Disponible"},
				{title: 'Rojo',Estado: "Suspendido"},
				{title: 'Lila',Estado: "Suspendido"},
				{title: 'Verde',Estado: "Suspendido"},
		]}],
		cabeceraSeriales: [
			{ text: 'Código Producto', value: 'codigoproducto', sortable: false  },
			{ text: 'Nombre Producto', value: 'descricion', sortable: false  },
			{ text: 'Código Serial', value: 'codigoSerial', sortable: false  },
			{ text: 'Estado ', value: 'estado', sortable: false  },
			{ text: 'Vencimiento ', value: 'vencimiento', sortable: false  },
			{ text: 'Proveedor ', value: 'proveedor', sortable: false  },
			{ text: 'Eliminar ', value: 'actionmovimiento', sortable: false  },
		],
		cabeceraCompuestos: [
			{ text: 'Descripción', value: 'descripcion'},
			{ text: 'Precio', value: 'precio'},  
			{ text: 'C_Compuesto', value: 'codigoCompuesto'},  
			{ text: 'C_Producto', value: 'codigoAsoiado'}, 
			{ text: 'Valor 0', value: 'actionvalor'},
			{ text: 'Eliminar', value: 'actionmovimiento'},
			],
		cabeceraDetalles: [
			{ text: 'Código', value: 'codigoProducto', sortable: false  },
			{ text: 'Descripción', value: 'descripcion', sortable: false  },
			{ text: 'Precio', value: 'precio', sortable: false  },
			{ text: 'Inv Actual', value: 'cantidad', sortable: false  },
			{ text: 'Localidad', value: 'localidad', sortable: false  },
			{ text: 'Cantidad Ingresar', value: 'actioncantidad', sortable: false  },
			{ text: 'Eliminar', value: 'actionmovimiento', sortable: false },
			],
		cabeceraAprobaciones: [
		{ text: 'Descripción', value: 'descripcion'  },
		{ text: 'Fecha', value: 'fecha' },
		{ text: 'Usuario', value: 'cajero' },
		{ text: 'Tipo', value: 'tipo' },
		{ text: 'Cantidad', value: 'cantidad' },
		{ text: 'Aprobar', value: 'actioncantidad', sortable: false  },
		{ text: 'Denegar', value: 'actionmovimiento', sortable: false },
		],
		ProveedoresDetalles: [
		{ text: 'Nombre', value: 'proveedor'},
		{ text: 'Tipo Ced', value: 'tipoCedula'},
		{ text: 'Cédula', value: 'cedula', sortable: false  },
		{ text: 'Correo', value: 'correo', sortable: false  },
		{ text: 'Dirección', value: 'direccion', sortable: false  },
		{ text: 'Eliminar', value: 'actionmovimiento', sortable: false },
		],
		precio_venta: 0,
		descripcion: '',
		valida: 0,
		Cat: '',
		CantPersonas: 2,
      	TipoMovimiento: [
         {text:'Entrada', value: 'INGRESO'},
         {text:'Salida', value:'SALIDA'}],
		activos: [
			{text:'SI', value: 0},
			{text:'NO', value:1}],
      	validaMensaje:[],
		Categoria: 'PRODUCTO',
		Categorias: ["PRODUCTO","INSUMO","SERVICIO","ACTIVO"],
		esProducto: true,
		Ivi: true,
		articulos:[],
		adModal: 0,
		activo:0,
		Mensaje: '',
		acabados: [],
		acabado: "",
		snackbar: false,
		menu2: false,
		menu3: false,
		menu4: false,
		menu5: false,
		menu6: false,
		menu7: false,
		menu8: false,
		menu9: false,
		hora: "00:10",
		hora2: "24:00",
		hora4: 1,
		adAccion: 0,
		adNombre: '',
		adId: '',
		barcode: '',
		cantidadIngreso: 0,
		cabys: 0,
		listaAprobaciones: [],
		selectedFile: null,
		Costo:'',
		loading: false,
		Tallas:[],
		costoacabado: 0,
		nombreAcabado: "",
		CodigoAcabado: "",
		cedulaproveedor: '',
		tpcedulaproveedor: '',
		nombreproveedor: '',
		stop: false,
		telefonoproveedor: '',
		correoproveedor: '',
		direccionproveedor: '',
		codigoProducto: '',
		proveedor:'Mi Tienda',
		modelCarga: true,
		categoria:13,
		uploadValue1: 0,
		Fecha: "",
		LocalidadesSelectas:[],
		uploadValue:0,
		familia:'NA',
		precio: 0,
		truevalue: true,
		modelinventario: false,
		familias:[],
		precioCompra:10,
		precioVenta: 0,
		precioMall: 0,
		precioCentral: 0,
		precioDetalle: 0,
		precioMayor: 0,
		maximo:5,
		minimo:1,
		tipoProducto:'',
		maxDescuento: 90,
		comision:1,
		codigoCABYS: "",
		IdProductKey:0,
		localidades:[],
		idProductKey: 0,
		localizacion:'https://noah.cr/ImagenesGenerales/usuario.png',
		compuesto: false,
		uploadValue: 0,
		switch1: true,
		codigo:"",
		cocina: 0,
		estado: 0,
		DatoMovimiento: '',
		acabadosSeleccionados:[],
		nombre: 'NA',
		SoN: 'S',
		productosVariacion:[],
		valorCero: false,
		localidad: "",
		productos: [],
		desserts: [],
		editedIndex: -1,
		acabadosFiltrados:[],
		Opciones:[],
		variaciones:[],
		editedItem: {
		
			name: '',
			calories: 0,
			fat: 0,
			gestionProveedor: [],
			carbs: 0,
			protein: 0,
		},
		defaultItem: {
			name: '',
			calories: 0,
			fat: 0,
			carbs: 0,
			protein: 0,
		},
    }),

    computed: {
		formTitle () {
			return this.editedIndex === -1 ? 'Agregar' : 'Actualizar'
		},
		esBoss(){
				return this.$store.state.usuario && this.$store.state.usuario.rol =='King Boss';
		},
		esMarketing(){
			return this.$store.state.usuario && this.$store.state.usuario.rol =='King Marketing';
		},
      
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
		this.listarAsociadas();
		this.selectProductos();
    },

    methods: {
    onChangeFileUpload(event){
      this.selectedFile = event.target.files[0];
      this.onUpload();
    },
	preventNonNumericInput(event) {
		// Si el caracter ingresado no es un número, lo previene
		if (!event.key.match(/[0-9]/)) {
		event.preventDefault();
		}
	},
	MoverInventario(){
		this.modelinventario= true
		this.selectProductos();
	},
	listarAsociadas(){
		var items = [];
		let me=this;
		me.Localidades.push(me.$store.state.usuario.localidad);
		this.localidad = this.$store.state.usuario.localidad;
		let header={"Authorization" : "Bearer "};
		let configuracion= {headers : header};
		axios.get('api/LocalidadesAsociadas/'+this.$store.state.usuario.nombre,configuracion).then(function(response){
			items=response.data;
			items.map(function(x){
				me.Localidades.push(x.localdiadAsociada);
			});
		}).catch(function(error){
			alert("Producto no encontrado");
			me.modelCarga=false;
		});
	},
    onUpload(){
      const storageRef=firebase.storage().ref(`${this.selectedFile.name}`);
      const task = storageRef.put(this.selectedFile);
      task.on('state_changed',snapshot=>{
        let percentage = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
        this.uploadValue = percentage;
      }, error=>{console.log(error.message)},
      ()=>{this.uploadValue=100;
          task.snapshot.ref.getDownloadURL().then((url)=>{
          this.localizacion =url;
        });
      }
      );
    },
	async generarTrazladoIngreso(){
		this.modelCarga = true;
		var me = this;
		var momentoActual = new Date() 
		var y = momentoActual.getFullYear();
		var m = momentoActual.getMonth() + 1;
		var d = momentoActual.getDate();
		var hora = momentoActual.getHours() 
		var minuto = momentoActual.getMinutes() 
		var segundo = momentoActual.getSeconds() 
		this.Fecha = m + "/" + d + "/" + y+"  "+hora+":"+minuto+":"+segundo;
		let header={"Authorization" : "Bearer " + this.$store.state.token};
		let configuracion= {headers : header};
		await axios.post('api/ProductosWebs/TrazladoMercaderiaIngreso',{
					'Usuario': this.$store.state.usuario.nombre,
					'localidad': this.localidaddestino,
					'detalles': me.detalles,
					'detalle': me.detalle,
					'Aprobado': me.switch1,
					'TipoIngreso': me.localidadorigen,
					
			},configuracion).then(function (response) {
				me.snackbar = true;
				me.Mensaje = "Trazlado de "+me.localidadorigen +" hacia "+me.localidaddestino+" realizado de forma exitosa";
				me.modeltrazlado = false;
				me.PrintDetails();
				me.detalles = [];
				me.modelCarga = false;
				})
				.catch(function (error) {
					me.modelCarga = false;
					alert(`Lo sentimos ha ocurrido un error, notifiuelo al 4070-1889`+error);  
			})   
    },
	encuentra(id){
		var sw=0;
		for(var i=0;i<this.detalles.length;i++){
			if (this.detalles[i].idarticulo==id){
				sw=1;
			}
		}
		return sw;
    },
	async generarInventario(){
		if(this.localidad == ""){
			this.Mensaje ="Seleccione una localidad para continuar"
			this.snackbar = true;
			return;
		}
		if (this.DatoMovimiento == ''){
			this.Mensaje = 'Seleccione el tipo de movimiento';
			this.snackbar = true;
			return
		
		}  {
		this.loading = true;
		var momentoActual = new Date() 
		var y = momentoActual.getFullYear();
		var m = momentoActual.getMonth() + 1;
		var d = momentoActual.getDate();
		var hora = momentoActual.getHours() 
		var minuto = momentoActual.getMinutes() 
		var segundo = momentoActual.getSeconds() 
		this.Fecha = m + "/" + d + "/" + y+"  "+hora+":"+minuto+":"+segundo;
		var me = this;
		let header={"Authorization" : "Bearer " + this.$store.state.token};
		let configuracion= {headers : header};
		await axios.post('api/ProductosWebs/MovimientoInventario',{
					'Usuario': this.$store.state.usuario.nombre,
					'localidad': this.localidad,
					'detalles': me.detalles,
					'detalle': me.detalle,
					'Aprobado': me.switch1,
					'TipoIngreso': me.DatoMovimiento,
					'NoFactura': me.idMovimiento,
					
			},configuracion).then(function (response) {
				me.Mensaje ="Movimiento realizado con éxito"
				me.snackbar = true;
				me.loading = false;
				me.finishOrder();
				//me.modelinventario = false;
				me.detalles = [];
				let barcodepreview = Date.now();
				let idsa = barcodepreview.toString();
				me.idMovimiento = idsa.substring(5, 12);
				
				})
				.catch(function (error) {
					alert(`Lo sentimos ha ocurrido un error, notifiuelo al 4070-1889`);  
			})
			} return;
    },
    initialize(){
        let me=this;
		this.modelCarga = true;
		this.familia = "";
		this.categoria = "";
        let barcodepreview = Date.now();
        let idsa = barcodepreview.toString();
        this.codigoProducto = idsa.substring(5, 12);
        this.barcode = idsa.substring(5, 12);
		this.idMovimiento = idsa.substring(5, 12);
        //let header={"Authorization" : "Bearer " + this.$store.state.token};
        let header={"Authorization" : "Bearer "};
        let configuracion= {headers : header};
          axios.get('api/Productos/ListarLocalidad/'+me.localidad,configuracion).then(function(response){
          me.articulos=response.data;
          me.modelCarga = false;
        }).catch(function(error){
            alert("Producto no encontrado");
			me.modelCarga = false;
        });
	},
	async Actualizar (item){
			this.loading = true;
			let me = this;
			let sinc = 1;
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			if(item.sincServer1 == true){
				sinc = 1;
			} else
			sinc = 0;
			await axios.put('api/Productos/Actualizar',{
				'codigoProducto':item.codigoProducto,
				'descripcion':item.descripcion,
				'barcode':item.barcode,
				'IdProductKey': item.idProductKey,
				'precioVenta':item.precioVenta,
				'precioDetalle':item.precioDetalle,
				'precioMall':item.PrecioMall,
				'precioMayor':item.precioMayor,
				'precioCentral':item.precioCentral,
				'precioCompra': item.precioCompra,
				'compuesto': item.compuesto,
				'Categoria':item.categoria, //Define si es un servicio o un Producto
				'Origen':item.origen, // Este campo es la hora inicial del servicio
				'InnerPack': item.innerPack, // Este campo es la Hora final del servicio
				'CantHoras': item.cantHoras, // Este campo define la cantidad de horas disponibles del servicio
				'comision': item.comision,
				'maxDescuento': item.maxDescuento,
				'proveedor': item.proveedor,
				'localizacion': item.localizacion,
				'Cocina':item.cocina,
				'minimo':item.minimo,
				'maximo':item.maximo,
				'EstadoInventario': item.estadoInventario,
				'valorImpuesto':item.valorImpuesto,
				'Exe_Grad':item.exe_Grad,
				'tipoProducto': item.tipoProducto,
				'SubFamilia': item.subFamilia,
				'Localidad' : item.localidad,
				'CantPersonas': item.cantPersonas,
				'CodigoRaiz': item.codigoRaiz,
				'MaxDescuento':item.maxDescuento,
				'SincServer1':sinc, // Mostrar Item en la web
				'Color':item.Color,
				'CodigoCaja':item.codigoCaja,
				'Medidas':item.medidas,
				'SKU':item.SKU,
				'Dimensiones':item.MaxFactura,
				'Actividad':item.ubicacion,
				'Pkg':item.pkg,
			},configuracion).then(function(response){
				me.Mensaje = "Producto actualizado con éxito en "+item.localidad;
				me.snackbar = true;      
				me.dialog = false;       
				//me.initializeFinder();
			}).catch(function(error){
				alert("Error actualizando, código interno no encontradoen "+me.localidad + error)
			});
		},
	initializeFinder(){
        let me=this;
		this.modelCarga = true;
		this.familia = "";
		this.categoria = "";
        let part1 = "";
		if (this.search.includes("/")) {
			let index = this.search.indexOf("/");
			part1 = this.search.substring(0, index);
		} else {
			part1 = this.search;
		}
        //let header={"Authorization" : "Bearer " + this.$store.state.token};
        let header={"Authorization" : "Bearer "};
        let configuracion= {headers : header};
          axios.get('api/Productos/ListarLocalidadBusqueda/'+me.localidad+'/'+part1,configuracion).then(function(response){
          me.articulos=response.data;
          me.modelCarga = false;
        }).catch(function(error){
			me.modelCarga = false;
            alert("Producto no encontrado");
			 
        });
	},
	eliminarProducto(id){
        //console.log(id)
        this.detalles = this.detalles.filter(e => e.id != id)
        //console.log(this.cards)
	},
	ListarLocalidadProductos(){
		let me=this;
		this.modelCarga = true;
		let barcodepreview = Date.now();
		let idsa = barcodepreview.toString();
		this.codigoProducto = idsa.substring(5, 12);
		this.barcode = idsa.substring(5, 12);
		//let header={"Authorization" : "Bearer " + this.$store.state.token};
		let header={"Authorization" : "Bearer "};
		let configuracion= {headers : header};
		axios.get('api/Productos/ListarLocalidad/'+me.localidad,configuracion).then(function(response){
		me.articulos=response.data;
		me.modelCarga = false;
		}).catch(function(error){
			alert("Producto no encontrado");
			me.modelCarga = false;
		});
	},
	close () {
		this.dialog = false;
        this.limpiar();
	},
	buscarCodigo(){
		let me=this;
		me.errorArticulo=null;
		if (this.codigo != "")
		{
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			axios.get('api/ProductosWebs/BuscarCodigoVentaLocalidad/'+this.codigo+'/'+this.$store.state.usuario.localidad,configuracion)
			.then(function(response){
				me.agregarDetalle(response.data);
			}).catch(function(error){
				alert("No existe el artículo");
			});
		}
		this.codigo = "";
    },
	buscarCodigoBarras(){
		let me=this;
		if (this.codigo != "")
		{
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			axios.get('api/ProductosWebs/BuscarCodigoBarrasLocalidad/'+this.codigo+'/'+this.$store.state.usuario.localidad,configuracion)
			.then(function(response){
				me.agregarDetalle(response.data);
			}).catch(function(error){
				me.Mensaje ="Articulo no encontrado, por favor verifique su código de barras";
				me.snackbar = true;
			});
		}
    },
      buscarProducto(){
		if(this.localidad == ""){
			this.Mensaje ="Seleccione una localidad para continuar"
			this.snackbar = true;
			return;
		}
		let me=this;
		me.errorArticulo=null;
		if (this.codigo != "")
		{
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			axios.get('api/ProductosWebs/BuscarCodigoVentaLocalidad/'+this.codigo.value+'/'+this.localidad,configuracion)
			.then(function(response){
				me.agregarDetalle(response.data);
			}).catch(function(error){
				alert("No existe el artículo");
			});
		}
    },
	selectProductos(){
		let me=this;
		let header={"Authorization" : "Bearer " };
		let configuracion= {headers : header};
		var productosArray=[];
		axios.get('api/Productos/SelectProductos/'+this.localidad,configuracion).then(function(response){
			productosArray=response.data;
			productosArray.map(function(x){
				me.productos.push({text:x.descripcion, value:x.codigoProducto});
			});
			me.modelCarga = false;
		}).catch(function(error){
			console.log(error);
		});
	},
	
    selectLocalidad(){
		let me=this;
		var localidadesArray=[];
		let header={"Authorization" : "Bearer "};
		let configuracion= {headers : header};
		axios.get('api/Localidades/SelectLocalidades',configuracion).then(function(response){
			localidadesArray=response.data;
			localidadesArray.map(function(x){
				me.localidades.push({text: x.nombre,value:x.nombre});
			});
		})
    },
	buscarProductoDirecto(){
		let me=this;
		if (this.codigo.value === undefined)
		{
			this.codigo = this.codigo;
		}
		else
		{
			this.codigo = this.codigo.value;
		}

		if (this.codigo != "")
		{
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			axios.get('api/Productos/BuscarCodigoVenta/'+this.codigo+'/'+this.$store.state.usuario.localidad,configuracion)
			.then(function(response){
				me.agregarDetalleDirecto(response.data);
			}).catch(function(error){
				// me.snackbar = true;
						//me.Mensaje = "Producto No encontrado";
			});
		}
	},
      editarProductoSuma(index){
        this.cantidades = this.detalles[index].cantidad
        this.indexProducto = index 
        this.detalles[this.indexProducto].cantidad = this.cantidades + 1
       // this.sumarCantidadProducto();
      },
      editarProductoResta(index){
          if(this.detalles[index].cantidad != 1){
            this.cantidades = this.detalles[index].cantidad
            this.indexProducto = index 
            this.detalles[this.indexProducto].cantidad = this.cantidades - 1
          } 
        
       // this.sumarCantidadProducto();
      },
      AñadirCodigo(item){
        this.modelCarga = true;
        this.modelSeriales = true;
        this.codigoProducto = item.codigoProducto;
        this.nombre = item.descripcion;
        let me=this;
                let header={"Authorization" : "Bearer " };
                let configuracion= {headers : header};
                var productosArray=[];
                axios.get('api/CodigosSeriales/ObtenerSerial/'+me.$store.state.usuario.localidad+'/'+me.codigoProducto,configuracion).then(function(response){
                    me.seriales=response.data;
                    me.modelCarga = false;
                }).catch(function(error){
                    me.modelCarga = false;
                    me.Mensaje = error;
                    me.snackbar = true;
                    console.log(error);
                });

      },
    agregarDetalle(data = []){
                this.errorArticulo=null;
                if (data['codigoProducto'] != '' && data['codigoProducto'] != undefined)
                {
                    this.codigo = data['codigoProducto'];
                }
                if (this.encuentra(data['codigoProducto'])){
                    alert("El producto ya ha sido agregado.");
                }
                else
                {
                  if (this.codigo != '')
                  {
                      this.detalles.push(
                        {
                        id: Date.now(),
						codigoProducto:data['codigoProducto'],
                        idarticulo:data['codigoProducto'],
                        descripcion:data['descripcion'],
                        cantidad:data['cantidadInvActual'],
                        precio:data['precioVenta'],
                        gravado:data['exe_Grad'],
                        cantidadIngreso: 0,
						localidad:data['sitio'],
                        }
                        );
                        
                      this.codigo = '';
                  }
                  else{
                    alert("Debe digitar un código de producto o servicio");
                  }
                }
    },
	finishOrder() {
		var divContents = document.getElementById("bill").innerHTML;
		var a = window.open('', '', 'height=500, width=500');
		
			a.document.write('<html>');
			a.document.write(divContents);
			a.document.write('</body></html>');
			a.document.close();
			a.print();
		
	},
    },
  }
</script>
<style lang="scss">>
    #espacioBoton {
        top: 10px;
    }
    /*#clienteBoton {
        bottom: 10px;
    }*/
    /* #clienteActualizar {
        bottom: 5px;
    }*/

    #factura {
        padding: 20px;
    }
    #ticket {
    width: 60px;
    max-width: 155px;
    }

    
    @import url('https://fonts.googleapis.com/css2?family=ABeeZee&family=Montserrat:wght@200;400&family=Open+Sans:wght@600&family=PT+Sans&display=swap');

    #logo {
        float: left;
        margin-left: 2%;
        margin-right: 2%;
    }
    #imagen {
        width: 100px;
    }

    #fact {
        font-size: 18px;
        font-weight: bold;
        text-align: center;
    }   

    #datos {
        float: left;
        margin-top: 0%;
        margin-left: 2%;
        margin-right: 2%;
    }

    #encabezado {
        text-align: center;
        margin-left: 10px;
        margin-right: 10px;
        font-size: 16px;
    }

    section {
        clear: left;
    }

    #cliente {
        text-align: left;
    }

    #facliente {
        width: 40%;
        border-collapse: collapse;
        border-spacing: 0;
        margin-bottom: 15px;
    }

    #fa {
        color: #FFFFFF;
        font-size: 14px;
    }
    @media print {
    .oculto-impresion,
    .oculto-impresion * {
        display: none !important;
    }
    }   
	/* Solid border */
	hr.solid {
	border-top: 3px solid #bbb;
	}
    #facarticulo {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;
        padding: 20px;
        margin-bottom: 15px;
    }

    #facarticulo thead {
        padding: 20px;
        background: #2183E3;
        text-align: center;
        border-bottom: 1px solid #FFFFFF;
    }

    #gracias {
        text-align: center;
    }
    tr.v-data-table__selected {
      background: #7d92f5 !important;
    }

    button#facturaBoton {
      margin: 18px;
    }

    button#hoyBoton {
      margin: 18px;
    }

    .tarjeta{
        margin-bottom: 15px!important;
        margin-top: 20px!important;
    }

    .efectivo{
        margin-bottom: 15px!important;
        margin-top: 20px!important;
    }

    .btnLimpiarGrid {
        margin-bottom: 20px;
    }

    button#productoBoton {
        top: 6px;
        margin-left: 35px;
    }

    td,
    th,
    tr,

    .v-dialog:not(.v-dialog--fullscreen) {
        max-height: 100%!important;
    }
    .centrado {
    text-align: center;
    align-content: center;
    }

    .ticket {
        width: 155px;
        max-width: 155px;
    }

    img {
        max-width: inherit;
        width: inherit;
    }
    .centrado {
    text-align: center;
    align-content: center;
    }

    .ticket {
        width: 200px;
        max-width: 200px;
    }

    img {
        max-width: inherit;
        width: inherit;
    }

</style>
My CRUD
